import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { listMarkets, type MarketRow } from "../api/markets";

export function Markets() {
  const [rows, setRows] = useState<MarketRow[]>([]);
  const [filter, setFilter] = useState("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    function load() {
      listMarkets()
        .then((r) => !cancelled && setRows(r))
        .catch((e) => !cancelled && setError(e.message));
    }
    load();
    const t = setInterval(load, 5000);
    return () => {
      cancelled = true;
      clearInterval(t);
    };
  }, []);

  const filtered = useMemo(
    () => rows.filter((r) => r.symbol.toLowerCase().includes(filter.toLowerCase())),
    [rows, filter],
  );

  return (
    <div className="page page-markets">
      <header className="page-header">
        <h1>Markets</h1>
        <input
          className="search"
          placeholder="Search symbol…"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        />
      </header>
      {error && <div className="error">{error}</div>}
      <table className="markets-table">
        <thead>
          <tr>
            <th>Symbol</th>
            <th>Name</th>
            <th className="num">Last</th>
            <th className="num">24h %</th>
            <th className="num">24h volume</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {filtered.map((r) => (
            <tr key={r.symbol}>
              <td>
                <Link to={`/trade/${r.symbol}`}>{r.symbol}</Link>
              </td>
              <td className="muted">{r.display_name}</td>
              <td className="num">${r.last.toFixed(2)}</td>
              <td className={r.change_24h_pct >= 0 ? "num up" : "num down"}>
                {r.change_24h_pct >= 0 ? "+" : ""}
                {r.change_24h_pct.toFixed(2)}%
              </td>
              <td className="num">${(r.volume_24h / 1_000_000).toFixed(2)}M</td>
              <td>
                <Link to={`/trade/${r.symbol}`} className="btn btn-ghost btn-sm">
                  Trade
                </Link>
              </td>
            </tr>
          ))}
          {filtered.length === 0 && !error && (
            <tr>
              <td colSpan={6} className="muted">
                No markets.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
